export enum INPUT_TYPES {
  PRICE = 'PRICE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  INT = 'INT',
  FLOAT = 'FLOAT',
  TIME = 'TIME',
  DATE = 'DATE',
  VAT = 'VAT',
  PERCENTAGE = 'PERCENTAGE',
}
